import './StatusBadge.scss';
import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';

interface IStatusBadgeProps {
  text: string;
  title?: string;
  customStartDecorator?: ReactNode;
  className?: string;
}

export const StatusBadge = ({ className, customStartDecorator, text, title }: IStatusBadgeProps): ReactElement => (
  <div
    className={classNames('status-badge', className)}
    title={title}
  >
    {customStartDecorator ?? <div className='status-badge-dot' />}
    <div className='status-badge-label'>{text}</div>
  </div>
);
